import { Component } from '@angular/core';
import { NavController,Tabs,Loading,LoadingController } from 'ionic-angular';
//import { ListPage } from '../../pages/list/list';
//import { ListPage } from '../pages/list/list';
import { AuthService } from '../../providers/auth';
import { ListPage } from '../../pages/list/list';
import { RidePage } from '../../pages/ride/ride';
import { DetailPage } from '../../pages/detail/detail';
import { RatePage } from '../../pages/rate/rate';
//import { HomePage } from '../../pages/home/home';



@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  loading: Loading;
  tab1Root: any = ListPage;
  tab2Root: any = ListPage;
  pet:any;
  datas: any[] = [];
  
  selectedItem: any;
  obj:any;
  obj2:any;
  obj3:any;
  items;
  items2;
  items3;
 //  @ViewChild(Tabs) tabs;
  constructor(public loadingCtrl: LoadingController,public navCtrl: NavController,public authService:AuthService) {
    this.pet = 'All';
  }

  //ismail
  //constructor(nav) {
  //  this.nav = nav
  //}

 //  aktualisieren() {
 //   this.nav.push(HomePage);
 // }
  //bis hierher

  kunde=localStorage.getItem('name');
  login={"company_id":localStorage.getItem('company_id'),"customer_id":localStorage.getItem('customers_id'),"Filter":'Today',"Loginid":localStorage.getItem('Loginid') };
  login_all={"company_id":localStorage.getItem('company_id'),"customer_id":localStorage.getItem('customers_id'),"Filter":'All'};

  login_Tomorrow={"company_id":localStorage.getItem('company_id'),"customer_id":localStorage.getItem('customers_id'),"Filter":'Tomorrow'};

  login_week={"company_id":localStorage.getItem('company_id'),"customer_id":localStorage.getItem('customers_id'),"Filter":'Weekly'};

  
  ionViewDidLoad() {

this.All();

 
  // let method='customer_order_details.php';
  // let temp={};
 
  // this.loading = this.loadingCtrl.create({
  // content: '',
  // });

  //  this.loading.present();
 //  console.log(data_parameters);

//    this.authService.postData(data_parameters,method).then((result) => {
 
//    this.obj = result;
//    console.log(this.obj);
   
//   if(this.obj.status=='true'){
//     this.items=this.obj.response;
//   //this.loading.dismissAll();
  
// //  localStorage.setItem("name",this.obj.name);
// //  localStorage.setItem("customers_id",this.obj.customers_id);
// //  localStorage.setItem("company_id",this.obj.company_id);

 
//   //this.navCtrl.setRoot(HomePage);
//    }
  
//   else{
//   // this.loading.dismissAll();
//    alert(this.obj.message);
//    }
   
//    }, (err) => {
//      // Error log
//  });







 
}

rate(itemdata){
 this.navCtrl.push(RatePage,{ data:itemdata})
}
getprofile(itemdata){

this.navCtrl.push(DetailPage,{ data:itemdata})

}
datamap(itemdata){
 this.navCtrl.push(RidePage,{ data:itemdata}) 
}

All(){
  this.loading = this.loadingCtrl.create({
    content: '',
    });
    this.loading.present();
  let data_parameters= this.login;
  console.log(data_parameters);
  let method='customer_order_details.php';

  this.authService.postData(data_parameters,method).then((result) => {
 
    this.obj = result;
    console.log(this.obj);
    
   if(this.obj.status=='true'){
     this.items=this.obj.response;
   //this.loading.dismissAll();
   this.loading.dismiss();
 //  localStorage.setItem("name",this.obj.name);
 //  localStorage.setItem("customers_id",this.obj.customers_id);
 //  localStorage.setItem("company_id",this.obj.company_id);
 
  
   //this.navCtrl.setRoot(HomePage);
    }
   
   else{
    this.loading.dismiss();
   // this.loading.dismissAll();
    //alert(this.obj.message);
    }
    
    }, (err) => {
      // Error log
  });

}


}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts